import { Form, FormElements, Link, Paragraph, validate } from "capitalrx-components-2.0";
import { useAlert } from "capitalrx-components-2.0/lib/general";
import { useRequestDiscountCardMutation } from "@/api/getAdvantageCard";
import { CardResponse, CloseModalProp } from "@/types/AdvantageCardRequest";
import { useGroupNumber } from "@/utils/useGroupNumber";
import { WhiteLabelSubmit } from "@/components/WhiteLabelComponents";

import styles from "../styles.module.scss";

const EmailModal = (props: CloseModalProp): JSX.Element => {
  const { onClose } = props;
  const group_number = useGroupNumber();

  const { TextField } = FormElements;
  const showAlert = useAlert();

  const [requestCard, requestCardResult] = useRequestDiscountCardMutation();

  const handleSubmit = async (payload: { discount_card_email: string }): Promise<CardResponse> => {
    await requestCard({
      request_type: 3,
      recipient: payload["discount_card_email"],
      group_number: group_number,
    })
      .unwrap()
      .then((data) => showAlert({ message: "Email sent. You should receive your discount card shortly.", type: "success", style: "toast" }))
      .catch((data) =>
        showAlert({ message: "Failed to email card. Please try again or contact customer support.", type: "error", style: "toast" }),
      );

    onClose();
    return requestCardResult.data;
  };

  return (
    <Form className={styles.ModalForm} onSubmit={handleSubmit}>
      <Paragraph className={styles.ModalFormTitle}>Email Discount Card</Paragraph>
      <Paragraph className={styles.ModalFormSubTitle}>Enter your email address below to send this discount card.</Paragraph>
      <TextField
        name="discount_card_email"
        id="email-advantage"
        type="text"
        placeholder="e.g., janedoe@address.com"
        validate={{ required: validate.required, validate: validate.isEmail }}
      />
      <WhiteLabelSubmit classNames={styles.ModalFormSubmit} text="Send Email" />
      <Paragraph className={styles.ModalFormDisclaimer}>
        By submitting, I agree to the{" "}
        <Link href="https://cap-rx.com/legal" title="Terms and privacy information">
          Privacy Policy &amp; Terms and Conditions
        </Link>
        .
      </Paragraph>
    </Form>
  );
};

export default EmailModal;
